import React, { useMemo } from 'react'
import { CrossClientResultSourceIcon } from '../Sources/CrossClientResultSourceIcon'
import { getCrossClientResultSourceLabel, sortSources } from '../Sources/utils'
import { type CrossClientQueryDataSource } from '../../../../models/CrossClient'
import { ReactComponent as ZocksIcon } from '../../../../assets/images/ZocksIcon-primary.svg'

interface CrossClientDataSourcesProps {
  sources: CrossClientQueryDataSource[]
}

export const CrossClientDataSources: React.FC<CrossClientDataSourcesProps> = ({ sources }) => {
  const sortedSources = useMemo(() => sortSources(sources), [sources])

  return (
    <>
      <h6>Data sources:</h6>
      <div className='d-flex flex-column gap-2'>
        <div className='d-flex gap-2 align-items-center'>
          <ZocksIcon width='0.75rem' height='0.75rem' />
          <div className='paragraph-small'>Zocks</div>
        </div>
        {sortedSources.map((source, idx) => {
          const sourceLabel = getCrossClientResultSourceLabel(source)
          return sourceLabel ? (
            <div key={idx} className='d-flex gap-2 align-items-center'>
              <CrossClientResultSourceIcon source={source} />
              <div className='paragraph-small'>{sourceLabel}</div>
            </div>
          ) : null
        })}
      </div>
    </>
  )
}
